import { Directive, Input, OnChanges, SimpleChanges, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[loadingAnimation]',
  standalone: false
})
export class LoadingAnimationDirective implements OnChanges {
  @Input('loadingAnimation') loading: boolean;
  @Input('loadingAnimationMinWidth') minwidth: string;
  @Input('loadingAnimationMinHeight') minheight: string;
  @Input('loadingAnimationMaxWidth') maxwidth: string;
  @Input('loadingAnimationMaxHeight') maxheight: string;
  @Input('loadingAnimationWidth') width: string;
  @Input('loadingAnimationHeight') height: string;

  private initialStyles = {
    minWidth: '',
    minHeight: '',
    maxWidth: '',
    maxHeight: '',
    width: '',
    height: ''
  };

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.initialStyles.minWidth = this.el.nativeElement.style.minWidth;
    this.initialStyles.minHeight = this.el.nativeElement.style.minHeight;
    this.initialStyles.maxWidth = this.el.nativeElement.style.maxWidth;
    this.initialStyles.maxHeight = this.el.nativeElement.style.maxHeight;
    this.initialStyles.width = this.el.nativeElement.style.width;
    this.initialStyles.height = this.el.nativeElement.style.height;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['loading']) {
      const loadingValue = changes['loading'].currentValue;
      this.updateLoadingState(loadingValue as boolean);
    }
  }

  private updateLoadingState(loading: boolean) {
    if (loading) {
      this.renderer.addClass(this.el.nativeElement, 'loading-animation');

      if (this.minwidth) this.renderer.setStyle(this.el.nativeElement, 'min-width', this.minwidth);
      if (this.minheight) this.renderer.setStyle(this.el.nativeElement, 'min-height', this.minheight);
      if (this.maxwidth) this.renderer.setStyle(this.el.nativeElement, 'max-width', this.maxwidth);
      if (this.maxheight) this.renderer.setStyle(this.el.nativeElement, 'max-height', this.maxheight);
      if (this.width) this.renderer.setStyle(this.el.nativeElement, 'width', this.width);
      if (this.height) this.renderer.setStyle(this.el.nativeElement, 'height', this.height);
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'loading-animation');

      this.renderer.setStyle(this.el.nativeElement, 'min-width', this.initialStyles.minWidth);
      this.renderer.setStyle(this.el.nativeElement, 'min-height', this.initialStyles.minHeight);
      this.renderer.setStyle(this.el.nativeElement, 'max-width', this.initialStyles.maxWidth);
      this.renderer.setStyle(this.el.nativeElement, 'max-height', this.initialStyles.maxHeight);
      this.renderer.setStyle(this.el.nativeElement, 'width', this.initialStyles.width);
      this.renderer.setStyle(this.el.nativeElement, 'height', this.initialStyles.height);
    }
  }
}
